/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
const FARVER = {
 blå: { bg: 'rgba(35,34,190,0.12)', border: '#2322be', dot: '#4140d4' },
 grøn: { bg: 'rgba(39,174,96,0.12)', border: '#27ae60', dot: '#27ae60' },
 gul: { bg: 'rgba(243,156,18,0.13)', border: '#f39c12', dot: '#f39c12' },
 orange: { bg: 'rgba(230,126,34,0.13)', border: '#e67e22', dot: '#e67e22' },
 lilla: { bg: 'rgba(142,68,173,0.12)', border: '#8e44ad', dot: '#8e44ad' },
};
const TYPER = [
 { id: 'notat', label: 'Notat', ikon: '' },
 { id: 'brainstorm', label: 'Brainstorm', ikon: '' },
 { id: 'beslutning', label: 'Beslutning', ikon: '' },
 { id: 'idé', label: 'Idé', ikon: '' },
];
function api(path, method = 'GET', body) {
 return fetch('/api/team-noter' + path, {
 method,
 credentials: 'include',
 headers: body ? { 'Content-Type': 'application/json' } : {},
 body: body ? JSON.stringify(body) : undefined,
 }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e.fejl || 'Fejl')));
}
// ── Brainstorm chat-kort ────────────────────────────────────────────────────
function BrainstormKort({ note, onOpdater, onSlet, onStartProjekt }) {
 const [svarStatus, setSvarStatus] = useState(note.os_svar_status || 'ingen');
 const [svar, setSvar] = useState(note.os_svar || null);
 const [samtale, setSamtale] = useState(note.samtale || []);
 const [opfoelgning, setOpfoelgning] = useState('');
 const [senderOpfoelgning, setSenderOpfoelgning] = useState(false);
 const [visStartProjekt, setVisStartProjekt] = useState(false);
 const [projekttitel, setProjekttitel] = useState(note.titel);
 const [opretterProjekt, setOpretterProjekt] = useState(false);
 const [redigerer, setRedigerer] = useState(false);
 const [indhold, setIndhold] = useState(note.indhold || '');
 const [titel, setTitel] = useState(note.titel);
 const [gemmer, setGemmer] = useState(false);
 const pollRef = useRef(null);
 const chatBundRef = useRef(null);
 const farve = FARVER[note.farve] || FARVER.blå;
 // Scroll til bunden når samtale opdateres
 useEffect(() => {
 if (chatBundRef.current) chatBundRef.current.scrollIntoView({ behavior: 'smooth' });
 }, [samtale, svar]);
 // Poll for AI-svar hvis afventer
 useEffect(() => {
 if (svarStatus !== 'afventer') return;
 pollRef.current = setInterval(async () => {
 try {
 const d = await api(`/${note.id}/svar-status`);
 if (d.os_svar_status === 'klar') {
 setSvarStatus('klar');
 if (d.samtale && d.samtale.length > 0) {
 setSamtale(d.samtale);
 } else {
 setSvar(d.os_svar);
 }
 clearInterval(pollRef.current);
 }
 } catch (_) {}
 }, 4000);
 return () => clearInterval(pollRef.current);
 }, [svarStatus, note.id]);
 async function sendOpfoelgning() {
 if (!opfoelgning.trim() || senderOpfoelgning) return;
 setSenderOpfoelgning(true);
 try {
 await api(`/${note.id}/opfoelgning`, 'POST', { indhold: opfoelgning.trim() });
 setSamtale(prev => [...prev, { rolle: 'bruger', tekst: opfoelgning.trim(), kl: new Date().toISOString() }]);
 setOpfoelgning('');
 setSvarStatus('afventer');
 } catch (e) {
 console.error(e);
 } finally {
 setSenderOpfoelgning(false);
 }
 }
 async function gem() {
 if (!titel.trim()) return;
 setGemmer(true);
 try {
 const opdateret = await api(`/${note.id}`, 'PATCH', { titel: titel.trim(), indhold });
 onOpdater(opdateret);
 setRedigerer(false);
 } catch (e) { console.error(e); }
 finally { setGemmer(false); }
 }
 async function slet() {
 if (!window.confirm('Arkivér denne brainstorm?')) return;
 await api(`/${note.id}`, 'DELETE');
 onSlet(note.id);
 }
 async function startProjekt() {
 if (!projekttitel.trim()) return;
 setOpretterProjekt(true);
 try {
 const res = await api(`/${note.id}/til-projekt`, 'POST', {
 titel: projekttitel.trim(),
 beskrivelse: note.indhold || '',
 });
 onStartProjekt(res);
 setVisStartProjekt(false);
 } catch (e) {
 alert('Fejl ved oprettelse af projekt: ' + e);
 } finally {
 setOpretterProjekt(false);
 }
 }
 return (
 <div style={{
 background: 'rgba(255,255,255,0.04)',
 border: `1px solid ${farve.border}`,
 borderRadius: 14,
 overflow: 'hidden',
 }}>
 {/* Header */}
 <div style={{
 background: `rgba(35,34,190,0.15)`,
 padding: '12px 16px',
 borderBottom: `1px solid ${farve.border}`,
 display: 'flex', alignItems: 'flex-start', gap: 8,
 }}> <span style={{ fontSize: 16 }}></span> <div style={{ flex: 1 }}>
 {redigerer ? (
 <input value={titel} onChange={e => setTitel(e.target.value)} autoFocus
 style={{ width: '100%', background: 'rgba(255,255,255,0.1)', border: `1px solid ${farve.border}`,
 borderRadius: 6, color: '#f1f5f9', padding: '4px 8px', fontSize: 14, fontWeight: 700 }} />
 ) : (
 <div style={{ fontWeight: 700, fontSize: 15, color: '#f1f5f9' }}>{note.titel}</div>
 )}
 <div style={{ fontSize: 11, color: 'rgba(241,245,249,0.4)', marginTop: 2 }}>
 {note.oprettet_af_navn || 'René'} ·{' '}
 {new Date(note.opdateret_kl).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
 {note.projekt_titel && <span style={{ color: '#3fd4c7' }}> · {note.projekt_titel.slice(0, 28)}</span>}
 </div> </div> <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
 {!redigerer && (
 <button onClick={() => setRedigerer(true)} title="Rediger" style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '4px 7px', fontSize: 13,
 }}></button>
 )}
 <button onClick={slet} title="Arkivér" style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '4px 7px', fontSize: 13,
 }}></button> </div> </div>
 {/* Chat-indhold */}
 <div style={{ padding: '16px' }}>
 {/* Renés brainstorm — højre side */}
 <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}> <div style={{
 maxWidth: '85%',
 background: 'rgba(35,34,190,0.25)',
 border: '1px solid rgba(65,64,212,0.4)',
 borderRadius: '14px 14px 4px 14px',
 padding: '12px 16px',
 }}>
 {redigerer ? (
 <> <textarea value={indhold} onChange={e => setIndhold(e.target.value)} rows={5}
 placeholder="Skriv din brainstorm her..."
 style={{ width: '100%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(65,64,212,0.3)',
 borderRadius: 6, color: '#f1f5f9', padding: '8px', fontSize: 13,
 resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} /> <div style={{ display: 'flex', gap: 8, marginTop: 8 }}> <button onClick={gem} disabled={gemmer} style={{
 background: farve.dot, border: 'none', borderRadius: 6,
 color: '#fff', cursor: 'pointer', padding: '6px 14px', fontSize: 13, fontWeight: 600,
 }}>{gemmer ? 'Gemmer…' : 'Gem'}</button> <button onClick={() => { setRedigerer(false); setTitel(note.titel); setIndhold(note.indhold || ''); }} style={{
 background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '6px 14px', fontSize: 13,
 }}>Annuller</button> </div> </>
 ) : note.indhold ? (
 <p style={{ margin: 0, fontSize: 13, color: '#e2e8f0', lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
 {note.indhold}
 </p>
 ) : (
 <p style={{ margin: 0, fontSize: 12, color: 'rgba(241,245,249,0.4)', fontStyle: 'italic' }}>
 Ingen indhold — klik for at tilføje
 </p>
 )}
 <div style={{ fontSize: 11, color: 'rgba(241,245,249,0.35)', marginTop: 6, textAlign: 'right' }}>
 René
 </div> </div> </div>
 {/* AI-svar — venstre side */}
 {svarStatus === 'afventer' && (
 <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 16 }}> <div style={{
 maxWidth: '85%',
 background: 'rgba(63,212,199,0.08)',
 border: '1px solid rgba(63,212,199,0.25)',
 borderRadius: '14px 14px 14px 4px',
 padding: '14px 16px',
 display: 'flex', alignItems: 'center', gap: 12,
 }}> <div style={{ display: 'flex', gap: 4 }}>
 {[0,1,2].map(i => (
 <div key={i} style={{
 width: 7, height: 7, borderRadius: '50%',
 background: '#3fd4c7',
 animation: `pulse 1.4s ease-in-out ${i * 0.2}s infinite`,
 }} />
 ))}
 </div> <span style={{ fontSize: 13, color: 'rgba(63,212,199,0.8)' }}>
 Afdelingerne analyserer…
 </span> <style>{`@keyframes pulse { 0%,80%,100%{opacity:0.3;transform:scale(0.8)} 40%{opacity:1;transform:scale(1)} }`}</style> </div> </div>
 )}
 {svarStatus === 'klar' && svar && samtale.length === 0 && (
 <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 16 }}> <div style={{
 maxWidth: '92%',
 background: 'rgba(63,212,199,0.07)',
 border: '1px solid rgba(63,212,199,0.3)',
 borderRadius: '14px 14px 14px 4px',
 padding: '14px 16px',
 }}> <div style={{ fontSize: 11, color: 'rgba(63,212,199,0.7)', marginBottom: 8, fontWeight: 600, letterSpacing: 0.5 }}>
 AFDELINGERNE · AI-ANALYSE
 </div> <div style={{
 fontSize: 13, color: '#e2e8f0', lineHeight: 1.7,
 whiteSpace: 'pre-wrap', wordBreak: 'break-word',
 }}>
 {svar}
 </div>
 {note.os_svar_kl && (
 <div style={{ fontSize: 11, color: 'rgba(241,245,249,0.3)', marginTop: 8 }}>
 {new Date(note.os_svar_kl).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
 </div>
 )}
 </div> </div>
 )}
 {/* Samtalehistorik — opfølgningsrunder */}
 {samtale.map((turn, i) => (
 <div key={i} style={{
 display: 'flex',
 justifyContent: turn.rolle === 'bruger' ? 'flex-end' : 'flex-start',
 marginBottom: 12,
 }}> <div style={{
 maxWidth: turn.rolle === 'bruger' ? '85%' : '92%',
 background: turn.rolle === 'bruger'
 ? 'rgba(35,34,190,0.25)'
 : 'rgba(63,212,199,0.07)',
 border: `1px solid ${turn.rolle === 'bruger' ? 'rgba(65,64,212,0.4)' : 'rgba(63,212,199,0.3)'}`,
 borderRadius: turn.rolle === 'bruger' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
 padding: '12px 16px',
 }}>
 {turn.rolle === 'assistent' && (
 <div style={{ fontSize: 11, color: 'rgba(63,212,199,0.7)', marginBottom: 6, fontWeight: 600, letterSpacing: 0.5 }}>
 AFDELINGERNE
 </div>
 )}
 <div style={{ fontSize: 13, color: '#e2e8f0', lineHeight: 1.7, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
 {turn.tekst}
 </div> <div style={{ fontSize: 11, color: 'rgba(241,245,249,0.3)', marginTop: 6, textAlign: turn.rolle === 'bruger' ? 'right' : 'left' }}>
 {turn.rolle === 'bruger' ? 'René' : null}
 {turn.kl ? ' · ' + new Date(turn.kl).toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' }) : null}
 </div> </div> </div>
 ))}
 {/* AI analyserer opfølgning */}
 {svarStatus === 'afventer' && samtale.length > 0 && (
 <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 12 }}> <div style={{
 background: 'rgba(63,212,199,0.08)',
 border: '1px solid rgba(63,212,199,0.25)',
 borderRadius: '14px 14px 14px 4px',
 padding: '12px 16px',
 display: 'flex', alignItems: 'center', gap: 12,
 }}> <div style={{ display: 'flex', gap: 4 }}>
 {[0,1,2].map(i => (
 <div key={i} style={{
 width: 6, height: 6, borderRadius: '50%',
 background: '#3fd4c7',
 animation: `pulse 1.4s ease-in-out ${i * 0.2}s infinite`,
 }} />
 ))}
 </div> <span style={{ fontSize: 12, color: 'rgba(63,212,199,0.8)' }}>Afdelingerne svarer…</span> </div> </div>
 )}
 {/* Opfølgnings-input — vises når AI har svaret */}
 {(svarStatus === 'klar') && (
 <div style={{ marginBottom: 12 }}> <div style={{
 display: 'flex', gap: 8, alignItems: 'flex-end',
 background: 'rgba(255,255,255,0.03)',
 border: '1px solid rgba(255,255,255,0.08)',
 borderRadius: 12,
 padding: '10px 12px',
 }}> <textarea
 value={opfoelgning}
 onChange={e => setOpfoelgning(e.target.value)}
 onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendOpfoelgning(); } }}
 placeholder="Stil et opfølgningsspørgsmål…"
 rows={2}
 style={{
 flex: 1, background: 'transparent', border: 'none', outline: 'none',
 color: '#f1f5f9', fontSize: 13, resize: 'none', fontFamily: 'inherit',
 lineHeight: 1.5,
 }}
 /> <button
 onClick={sendOpfoelgning}
 disabled={!opfoelgning.trim() || senderOpfoelgning}
 style={{
 background: opfoelgning.trim() ? 'rgba(35,34,190,0.6)' : 'rgba(255,255,255,0.05)',
 border: `1px solid ${opfoelgning.trim() ? 'rgba(65,64,212,0.6)' : 'rgba(255,255,255,0.1)'}`,
 borderRadius: 8, color: opfoelgning.trim() ? '#e2e8f0' : '#4a5568',
 cursor: opfoelgning.trim() ? 'pointer' : 'default',
 padding: '8px 14px', fontSize: 13, fontWeight: 600,
 transition: 'all 0.15s', whiteSpace: 'nowrap', flexShrink: 0,
 }}
 >
 {senderOpfoelgning ? '…' : 'Send ↵'}
 </button> </div> </div>
 )}
 <div ref={chatBundRef} />
 {/* Start projekt */}
 {svarStatus === 'klar' && !note.projekt_id && (
 <div style={{ marginTop: 8 }}>
 {!visStartProjekt ? (
 <button onClick={() => setVisStartProjekt(true)} style={{
 background: 'linear-gradient(135deg, #27ae60, #2ecc71)',
 border: 'none', borderRadius: 8, color: '#fff',
 cursor: 'pointer', padding: '9px 18px', fontSize: 13, fontWeight: 700,
 display: 'flex', alignItems: 'center', gap: 6,
 boxShadow: '0 4px 16px rgba(39,174,96,0.35)',
 transition: 'transform 0.15s',
 }}
 onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-1px)'}
 onMouseLeave={e => e.currentTarget.style.transform = ''}
 >
 Start projekt
 </button>
 ) : (
 <div style={{
 background: 'rgba(39,174,96,0.1)',
 border: '1px solid rgba(39,174,96,0.3)',
 borderRadius: 10, padding: '14px',
 }}> <div style={{ fontSize: 13, color: 'rgba(241,245,249,0.7)', marginBottom: 8 }}>
 Projekttitel:
 </div> <input
 value={projekttitel}
 onChange={e => setProjekttitel(e.target.value)}
 autoFocus
 style={{
 width: '100%', background: 'rgba(255,255,255,0.08)',
 border: '1px solid rgba(39,174,96,0.4)', borderRadius: 7,
 color: '#f1f5f9', padding: '9px 12px', fontSize: 14, fontWeight: 600,
 marginBottom: 10, boxSizing: 'border-box',
 }}
 /> <div style={{ display: 'flex', gap: 8 }}> <button onClick={startProjekt} disabled={opretterProjekt || !projekttitel.trim()} style={{
 background: 'linear-gradient(135deg, #27ae60, #2ecc71)',
 border: 'none', borderRadius: 7, color: '#fff',
 cursor: 'pointer', padding: '8px 18px', fontSize: 13, fontWeight: 700,
 opacity: !projekttitel.trim() ? 0.6 : 1,
 }}>{opretterProjekt ? 'Opretter…' : ' Opret projekt'}</button> <button onClick={() => setVisStartProjekt(false)} style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 7,
 color: '#94a3b8', cursor: 'pointer', padding: '8px 14px', fontSize: 13,
 }}>Annuller</button> </div> </div>
 )}
 </div>
 )}
 {note.projekt_id && (
 <div style={{
 background: 'rgba(63,212,199,0.08)',
 border: '1px solid rgba(63,212,199,0.2)',
 borderRadius: 8, padding: '8px 14px',
 fontSize: 12, color: 'rgba(63,212,199,0.8)',
 display: 'flex', alignItems: 'center', gap: 6,
 }}>
 Projekt oprettet: <strong>{note.projekt_titel || 'Se Projekter'}</strong> </div>
 )}
 </div> </div>
 );
}
// ── Almindelig note-kort ────────────────────────────────────────────────────
function NoteKort({ note, onOpdater, onSlet }) {
 const [redigerer, setRedigerer] = useState(false);
 const [indhold, setIndhold] = useState(note.indhold || '');
 const [titel, setTitel] = useState(note.titel);
 const [gemmer, setGemmer] = useState(false);
 const farve = FARVER[note.farve] || FARVER.blå;
 const type = TYPER.find(t => t.id === note.type) || TYPER[0];
 async function gem() {
 if (!titel.trim()) return;
 setGemmer(true);
 try {
 const opdateret = await api(`/${note.id}`, 'PATCH', { titel: titel.trim(), indhold });
 onOpdater(opdateret);
 setRedigerer(false);
 } catch (e) { console.error(e); }
 finally { setGemmer(false); }
 }
 async function slet() {
 if (!window.confirm('Arkivér denne note?')) return;
 await api(`/${note.id}`, 'DELETE');
 onSlet(note.id);
 }
 return (
 <div style={{
 background: farve.bg,
 border: `1px solid ${farve.border}`,
 borderRadius: 12,
 padding: '16px 18px',
 transition: 'box-shadow 0.2s',
 }}> <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8 }}> <span style={{ fontSize: 16 }}>{type.ikon}</span> <div style={{ flex: 1 }}>
 {redigerer ? (
 <input value={titel} onChange={e => setTitel(e.target.value)}
 style={{ width: '100%', background: 'rgba(255,255,255,0.15)',
 border: `1px solid ${farve.border}`, borderRadius: 6,
 color: '#f1f5f9', padding: '4px 8px', fontSize: 14, fontWeight: 600 }}
 autoFocus />
 ) : (
 <div style={{ fontWeight: 600, fontSize: 14, color: '#f1f5f9', lineHeight: 1.3 }}>{note.titel}</div>
 )}
 <div style={{ fontSize: 11, color: 'rgba(241,245,249,0.45)', marginTop: 3 }}>
 {note.oprettet_af_navn || 'Ukendt'} ·{' '}
 {new Date(note.opdateret_kl).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
 {note.projekt_titel && <span> · {note.projekt_titel.slice(0, 30)}</span>}
 </div> </div> <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}> <button onClick={() => setRedigerer(!redigerer)} title="Rediger" style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '4px 7px', fontSize: 13,
 }}></button> <button onClick={slet} title="Arkivér" style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '4px 7px', fontSize: 13,
 }}></button> </div> </div>
 {redigerer ? (
 <div> <textarea value={indhold} onChange={e => setIndhold(e.target.value)} rows={5}
 placeholder="Skriv din note her..."
 style={{ width: '100%', background: 'rgba(255,255,255,0.1)',
 border: `1px solid ${farve.border}`, borderRadius: 6,
 color: '#f1f5f9', padding: '8px', fontSize: 13,
 resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} /> <div style={{ display: 'flex', gap: 8, marginTop: 8 }}> <button onClick={gem} disabled={gemmer} style={{
 background: farve.dot, border: 'none', borderRadius: 6,
 color: '#fff', cursor: 'pointer', padding: '6px 14px', fontSize: 13, fontWeight: 600,
 }}>{gemmer ? 'Gemmer…' : 'Gem'}</button> <button onClick={() => { setRedigerer(false); setTitel(note.titel); setIndhold(note.indhold || ''); }} style={{
 background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 6,
 color: '#94a3b8', cursor: 'pointer', padding: '6px 14px', fontSize: 13,
 }}>Annuller</button> </div> </div>
 ) : note.indhold ? (
 <p style={{ margin: 0, fontSize: 13, color: 'rgba(241,245,249,0.75)',
 lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{note.indhold}</p>
 ) : (
 <p style={{ margin: 0, fontSize: 12, color: 'rgba(241,245,249,0.3)', fontStyle: 'italic' }}>
 Ingen indhold endnu — klik for at tilføje
 </p>
 )}
 </div>
 );
}
// ── Ny note formular ────────────────────────────────────────────────────────
function NyNoteFormular({ onOprettet }) {
 const [åben, setÅben] = useState(false);
 const [titel, setTitel] = useState('');
 const [indhold, setIndhold] = useState('');
 const [type, setType] = useState('brainstorm');
 const [farve, setFarve] = useState('blå');
 const [gemmer, setGemmer] = useState(false);
 const titelRef = useRef(null);
 useEffect(() => { if (åben && titelRef.current) titelRef.current.focus(); }, [åben]);
 async function opret(e) {
 e.preventDefault();
 if (!titel.trim()) return;
 setGemmer(true);
 try {
 const note = await api('', 'POST', { titel: titel.trim(), indhold, type, farve });
 onOprettet(note);
 setTitel(''); setIndhold(''); setType('brainstorm'); setFarve('blå');
 setÅben(false);
 } catch (e) { console.error(e); }
 finally { setGemmer(false); }
 }
 if (!åben) return (
 <button onClick={() => setÅben(true)} style={{
 background: 'linear-gradient(135deg, #2322be, #4140d4)',
 border: 'none', borderRadius: 12, color: '#fff',
 cursor: 'pointer', padding: '12px 20px', fontSize: 14, fontWeight: 600,
 display: 'flex', alignItems: 'center', gap: 8,
 boxShadow: '0 4px 20px rgba(35,34,190,0.3)',
 transition: 'transform 0.15s, box-shadow 0.15s',
 }}
 onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 28px rgba(35,34,190,0.45)'; }}
 onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 4px 20px rgba(35,34,190,0.3)'; }}
 > <span style={{ fontSize: 18 }}>+</span> Ny note / brainstorm
 </button>
 );
 return (
 <form onSubmit={opret} style={{
 background: 'rgba(255,255,255,0.05)',
 border: '1px solid rgba(63,212,199,0.2)',
 borderRadius: 14, padding: '20px',
 }}> <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}> <div style={{ display: 'flex', gap: 6 }}>
 {TYPER.map(t => (
 <button key={t.id} type="button" onClick={() => setType(t.id)} style={{
 background: type === t.id ? 'rgba(35,34,190,0.4)' : 'rgba(255,255,255,0.06)',
 border: type === t.id ? '1px solid #4140d4' : '1px solid rgba(255,255,255,0.1)',
 borderRadius: 8, color: '#f1f5f9', cursor: 'pointer',
 padding: '5px 10px', fontSize: 12,
 }}>{t.ikon} {t.label}</button>
 ))}
 </div> <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
 {Object.entries(FARVER).map(([navn, f]) => (
 <button key={navn} type="button" onClick={() => setFarve(navn)} style={{
 width: 22, height: 22, borderRadius: '50%',
 background: f.dot, border: farve === navn ? '3px solid #fff' : '2px solid transparent',
 cursor: 'pointer', padding: 0,
 }} title={navn} />
 ))}
 </div> </div> <input ref={titelRef} value={titel} onChange={e => setTitel(e.target.value)}
 placeholder={type === 'brainstorm' ? 'Hvad vil du brainstorme? (fx: Skal vi købe en Sharp TV?)' : 'Titel…'}
 required style={{
 width: '100%', background: 'rgba(255,255,255,0.08)',
 border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8,
 color: '#f1f5f9', padding: '10px 14px', fontSize: 15, fontWeight: 600,
 marginBottom: 10, boxSizing: 'border-box',
 }} /> <textarea value={indhold} onChange={e => setIndhold(e.target.value)}
 placeholder={type === 'brainstorm'
 ? 'Beskriv konteksten og hvad du ønsker afdelingernes input til…'
 : 'Skriv indhold, idéer, tanker…'}
 rows={5}
 style={{
 width: '100%', background: 'rgba(255,255,255,0.06)',
 border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8,
 color: '#f1f5f9', padding: '10px 14px', fontSize: 13,
 resize: 'vertical', fontFamily: 'inherit', marginBottom: 12,
 boxSizing: 'border-box', lineHeight: 1.6,
 }} />
 {type === 'brainstorm' && (
 <div style={{
 background: 'rgba(63,212,199,0.08)', border: '1px solid rgba(63,212,199,0.2)',
 borderRadius: 8, padding: '9px 14px', marginBottom: 12, fontSize: 12,
 color: 'rgba(63,212,199,0.8)', display: 'flex', alignItems: 'center', gap: 6,
 }}>
 Afdelingerne analyserer automatisk og svarer inden for et par minutter
 </div>
 )}
 <div style={{ display: 'flex', gap: 10 }}> <button type="submit" disabled={gemmer || !titel.trim()} style={{
 background: 'linear-gradient(135deg, #2322be, #4140d4)',
 border: 'none', borderRadius: 8, color: '#fff',
 cursor: 'pointer', padding: '9px 22px', fontSize: 14, fontWeight: 600,
 opacity: !titel.trim() ? 0.5 : 1,
 }}>{gemmer ? 'Opretter…' : type === 'brainstorm' ? ' Start brainstorm' : 'Gem note'}</button> <button type="button" onClick={() => setÅben(false)} style={{
 background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 8,
 color: '#94a3b8', cursor: 'pointer', padding: '9px 18px', fontSize: 14,
 }}>Annuller</button> </div> </form>
 );
}
// ── Hoved-komponent ─────────────────────────────────────────────────────────
export default function OSTeamNoter() {
 const [noter, setNoter] = useState([]);
 const [indlæser, setIndlæser] = useState(true);
 const [søgning, setSøgning] = useState('');
 const [filterType, setFilterType] = useState('');
 useEffect(() => {
 api('').then(d => { setNoter(d); setIndlæser(false); })
 .catch(() => setIndlæser(false));
 }, []);
 const filtreretNoter = noter.filter(n => {
 if (filterType && n.type !== filterType) return false;
 if (søgning) {
 const s = søgning.toLowerCase();
 return n.titel.toLowerCase().includes(s) || (n.indhold || '').toLowerCase().includes(s);
 }
 return true;
 });
 function handleStartProjekt(res) {
 alert(` Projekt "${res.projekt.titel}" oprettet! Du kan se det under Projekter.`);
 api('').then(setNoter).catch(() => {});
 }
 return (
 <div style={{ padding: '28px 32px', maxWidth: 960 }}> <div style={{ marginBottom: 28 }}> <h2 style={{ margin: '0 0 6px', fontSize: 24, fontWeight: 800, color: '#f1f5f9' }}>
 Teamnotater &amp; Brainstorm
 </h2> <p style={{ margin: 0, color: 'rgba(241,245,249,0.5)', fontSize: 14 }}>
 Brainstorm med firmaets afdelinger — AI-svar automatisk, og konvertér beslutninger til projekter
 </p> </div> <div style={{ marginBottom: 24 }}> <NyNoteFormular onOprettet={n => setNoter(prev => [n, ...prev])} /> </div>
 {noter.length > 0 && (
 <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}> <input value={søgning} onChange={e => setSøgning(e.target.value)}
 placeholder="Søg i noter…"
 style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
 borderRadius: 8, color: '#f1f5f9', padding: '8px 14px', fontSize: 13,
 flex: '1 1 200px', minWidth: 150 }} /> <div style={{ display: 'flex', gap: 6 }}> <button onClick={() => setFilterType('')} style={{
 background: !filterType ? 'rgba(35,34,190,0.4)' : 'rgba(255,255,255,0.06)',
 border: !filterType ? '1px solid #4140d4' : '1px solid rgba(255,255,255,0.1)',
 borderRadius: 8, color: '#f1f5f9', cursor: 'pointer', padding: '6px 12px', fontSize: 12,
 }}>Alle</button>
 {TYPER.map(t => (
 <button key={t.id} onClick={() => setFilterType(filterType === t.id ? '' : t.id)} style={{
 background: filterType === t.id ? 'rgba(35,34,190,0.4)' : 'rgba(255,255,255,0.06)',
 border: filterType === t.id ? '1px solid #4140d4' : '1px solid rgba(255,255,255,0.1)',
 borderRadius: 8, color: '#f1f5f9', cursor: 'pointer', padding: '6px 12px', fontSize: 12,
 }}>{t.ikon} {t.label}</button>
 ))}
 </div> </div>
 )}
 {indlæser ? (
 <div style={{ color: 'rgba(241,245,249,0.4)', textAlign: 'center', padding: '40px 0', fontSize: 15 }}>
 Henter noter…
 </div>
 ) : filtreretNoter.length === 0 ? (
 <div style={{ textAlign: 'center', padding: '60px 20px', color: 'rgba(241,245,249,0.3)', fontSize: 15 }}>
 {søgning || filterType
 ? 'Ingen noter matcher filteret.'
 : 'Ingen noter endnu. Start din første brainstorm ovenfor! '}
 </div>
 ) : (
 <div style={{
 display: 'grid',
 gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
 gap: 16,
 alignItems: 'start',
 }}>
 {filtreretNoter.map(note =>
 note.type === 'brainstorm' ? (
 <BrainstormKort
 key={note.id}
 note={note}
 onOpdater={opdateret => setNoter(prev => prev.map(n => n.id === opdateret.id ? opdateret : n))}
 onSlet={id => setNoter(prev => prev.filter(n => n.id !== id))}
 onStartProjekt={handleStartProjekt}
 />
 ) : (
 <NoteKort
 key={note.id}
 note={note}
 onOpdater={opdateret => setNoter(prev => prev.map(n => n.id === opdateret.id ? opdateret : n))}
 onSlet={id => setNoter(prev => prev.filter(n => n.id !== id))}
 />
 )
 )}
 </div>
 )}
 {filtreretNoter.length > 0 && (
 <p style={{ marginTop: 16, fontSize: 12, color: 'rgba(241,245,249,0.25)', textAlign: 'right' }}>
 {filtreretNoter.length} {filtreretNoter.length === 1 ? 'note' : 'noter'}
 </p>
 )}
 </div>
 );
}